import React from 'react';
import { BaseComponent } from '..';
import history from "../../history";
import config from '../../config';
import { ActionsApi } from '../../api/Actions';
import { BalanceApi, DigitalDepositApi } from '../../api';
import { hasAtLeastOneSelfEmployedAccount, getSelfEmployedAccountsWithTypes, processDataWithSelfEmployedFlag } from '../../utils/dataProcessor';


export default class CommonActions extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isGemelExsist: false,
            isHishtalmutExsist: false,
            hasSelfEmployedAccount: false,
            gemelData: null,
            hasAvailableDeposit: false,
            isShowDigitalDeposit: false

        }

    }

    moveTopage = (formTypeId) => {
        this.setState({
            loading: true
        })

        const type = formTypeId;

        formTypeId = formTypeId == 132 ? 3 : formTypeId;
        ActionsApi.get(formTypeId).then(res => {

            switch (type) {
                case 2: window.location.href = `${config.API_URL}/forms/transfer-between-courses/${res}`;
                    break;
                case 132: window.location.href = `${config.API_URL}/forms/hishtalmut/${res}`;
                    break
                case 3: window.location.href = `${config.API_URL}/forms/withdrawal/${res}`;
                    break;
                case 21: window.location.href = `${config.API_URL}/forms/digital-deposit/${res}`;
                     break;
                // case 7: window.location.href = `${config.API_URL}/forms/billing-instruction/${res}`
                //     break;
                // case 15: window.location.href = `${config.API_URL}/forms/joining-investment/${res}`
                //     break;
                // case 8: window.location.href = `${config.API_URL}/forms/joining-hishtalmut/${res}`
                //     break;
                default:
                    break;

            }


        }).finally(() => {
            this.setState({
                loading: false
            })
        });



    }


    componentDidMount() {
        BalanceApi.get().then(res => {
            const selfEmployedAccounts = getSelfEmployedAccountsWithTypes(res?.products || []);
            const hasSelfEmployed = selfEmployedAccounts.length > 0;
            const prodTypes = Array.from(new Set((res?.products).map((item) => item.prodType)));

            // Check if user has prodType 4 (digital deposit product)
            if (prodTypes.includes(4)) {
                DigitalDepositApi.customerAvailableFund().then(digitalDepositRes => {
                    let shouldExcludeSelfEmployed = false;
                    
                    if (digitalDepositRes && Array.isArray(digitalDepositRes)) {
                        const prodType4Data = digitalDepositRes.find(item => item.prodType === 4);
                        if (prodType4Data && prodType4Data.availableDepositAmount < 0) {
                            const hasSelfEmployedType4 = selfEmployedAccounts.some(account => account.productType === 4);
                            const hasSelfEmployedOtherTypes = selfEmployedAccounts.some(account => account.productType !== 4);
                            
                            if (hasSelfEmployedType4 && !hasSelfEmployedOtherTypes) {
                                shouldExcludeSelfEmployed = true;
                            }
                        }
                    }
                    
                    const isShowDigitalDeposit = hasSelfEmployed && !shouldExcludeSelfEmployed;
                    
                    this.setState({
                        isShowDigitalDeposit: isShowDigitalDeposit
                    });
                }).catch(error => {
                    console.error("Error calling DigitalDepositApi:", error);
                });
            } else {
                // If no prodType 4, but user has self-employed accounts, show digital deposit
                this.setState({
                    isShowDigitalDeposit: hasSelfEmployed
                });
            }
            
            this.setState({
                isGemelExsist: prodTypes.includes(4) ? true : false,
                isHishtalmutExsist: prodTypes.includes(2) ? true : false
            })
        });
    }



    render() {
        return <>
            <div className='common-action-page'>

                <div className='sub-title'>
                    <span>  פעולות נפוצות </span>

                </div>

                {
                    this.state.loading ? <div style={{ textAlign: "center", paddingTop: "2em" }}>
                        <img src="/img/loading.gif" alt="loading" />
                    </div> : <>


                        <div className='wrap-img-desc'>
                            {this.isFormShownInLobby(2) && <img onClick={() => { this.moveTopage(2) }} className='image-view' src='img/mobile-action-img/Group_18834.png' />}
                            {/* The digital deposit form: shown only to a user who can deposit, and only while the
                                form is published in the lobby. */}
                            {this.state.isShowDigitalDeposit && this.isFormShownInLobby(21) && (
                                <img onClick={() => { this.moveTopage(21) }} className='image-view' src='img/mobile-action-img/Group_6.png' />
                            )}
                            {/* The deposit information page, for a user who cannot deposit digitally. Independent of
                                the form above - it must not appear or disappear because of the form's lobby flag. */}
                            {!this.state.isShowDigitalDeposit && (
                                <img onClick={() => { window.open('https://contact.yl-invest.co.il/deposits.html') }} className='image-view' src='img/mobile-action-img/Group_18883.png' />
                            )}
                            {this.state.isHishtalmutExsist && this.isFormShownInLobby(132) && <img onClick={() => { this.moveTopage(132) }} className='image-view' src='img/mobile-action-img/Group_18877.png' />}
                            {!this.state.isHishtalmutExsist && this.state.isGemelExsist && this.isFormShownInLobby(3) && <img onClick={() => { this.moveTopage(3) }} className='image-desc' src='img/mobile-action-img/Group_188344.png' />}

                            {!this.state.isHishtalmutExsist && !this.state.isGemelExsist &&
                            <img onClick={() => {
                                window.open('https://www.yl-invest.co.il/uploads/n/1727790861.3880.pdf')
                            }} className='image-view'  src='img/mobile-action-img/Group_18884.png' />  }


                            <img onClick={() => {
                                history.push("/customers/home/all-actions")

                            }} className='image-view' src='img/mobile-action-img/Group_18837.png' />
                        </div>

                        <div className='wrap-img-mobile'>
                            {this.isFormShownInLobby(2) && <img onClick={() => { this.moveTopage(2) }} className='image-view' src='img/mobile-action-img/Group_18834.png' />}
                            {/* The digital deposit form: shown only to a user who can deposit, and only while the
                                form is published in the lobby. */}
                            {this.state.isShowDigitalDeposit && this.isFormShownInLobby(21) && (
                                <img onClick={() => { this.moveTopage(21) }} className='image-view' src='img/mobile-action-img/Group_6.png' />
                            )}
                            {/* The deposit information page, for a user who cannot deposit digitally. Independent of
                                the form above - it must not appear or disappear because of the form's lobby flag. */}
                            {!this.state.isShowDigitalDeposit && (
                                <img onClick={() => { window.open('https://contact.yl-invest.co.il/deposits.html') }} className='image-view' src='img/mobile-action-img/Group_18883.png' />
                            )}

                            {this.state.isHishtalmutExsist && this.isFormShownInLobby(132) && <img onClick={() => { this.moveTopage(132) }} className='image-view' src='img/mobile-action-img/Group_18877.png' />}




                            {!this.state.isHishtalmutExsist && this.state.isGemelExsist && this.isFormShownInLobby(3) && <img onClick={() => { this.moveTopage(3) }} className='image-desc' src='img/mobile-action-img/Group_188344.png' />}

                            {!this.state.isHishtalmutExsist && !this.state.isGemelExsist &&
                            <img onClick={() => {
                                window.open('https://www.yl-invest.co.il/uploads/n/1727790861.3880.pdf')
                            }} className='image-view'  src='img/mobile-action-imgGroup_18884.png'  />  }
                           
                            <img onClick={() => {
                                history.push("/customers/home/all-actions")

                            }} className='image-view' src='img/mobile-action-img/Group_18837.png' />
                        </div>

                    </>}

            </div>


            <style>
                {" "}
                {
                    "@media (max-width:991px) { .wrap-img-desc{display:none !important} }"
                }{" "}
            </style>
            <style>
                {" "}
                {
                    "@media (min-width:991px) { .wrap-img-mobile{display:none !important} }"
                }{" "}
            </style>
        </>
    }
}
